<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/content" color="error" icon flat exact>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Create Content</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex xs12 sm11 md10 lg9>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else row wrap justify-center>
        <v-flex class="px-2 pb-2" xs12 md7>
          <v-text-field
            label="Content Name"
            v-model.trim="newContent.name"
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 md10>
          <v-text-field
            label="Instructions"
            v-model.trim="newContent.instructions"
            rows="3"
            hide-details
            textarea
          ></v-text-field>
        </v-flex>
        <v-flex class="px-2 pb-3" xs12 md10>
          <v-card class="pa-0 elevation-0">
            <r-quill :options="options" :content="newContent.descText"></r-quill>
          </v-card>
        </v-flex>
        <v-flex class="px-2 pb-4 text-xs-center" xs12>
          <v-btn
            @click.native="canCreate"
            class="my-0"
            color="success"
            :loading="creating"
            :disabled="creating"
            large
          >Create</v-btn>
          <v-btn @click.native="popup.type = 'Resetting', popup.show = true" class="my-0" color="error" large flat>
            <b>Reset</b>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-content-popup
    :popup="popup"
    :content-data="newContent"
  ></r-content-popup>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import Quill from '../general/Quill.vue'
import ContentPopup from './ContentPopup.vue'
import {quillEvent, contentEvent} from '../../main'
export default {
  components: {
    rQuill: Quill,
    rContentPopup: ContentPopup,
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    creating: false,
    content: [],
    newContent: {},
    newText: '',
    quillText: '',
    options: {
      modules: {
        toolbar: [
          [{'header': [1, 2, 3, 4, 5, 6, false]}],
          [],
          ['bold', 'italic', 'underline'],
          [],
          [{'align': []}],
          [],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [],
          [{'color': []}, {'background': []}]
        ]
      },
      theme: 'snow',
      placeholder: 'Content Description'
    },
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    quillEvent.$on('quillContent', data => {
      const quill = {...data}
      let d = quill.html
      while (d.includes('ql-align-center') || d.includes('ql-align-right')) {
        d = d.replace('ql-align-center', 'text-xs-center')
        d = d.replace('ql-align-right', 'text-xs-right')
      }
      this.newText = d
      this.quillText = quill.text
    })
    contentEvent.$on('reset', () => {
      this.resetNewContent()
    })
    contentEvent.$on('createContent', () => {
      this.createContent()
    })
  },
  methods: {
    load () {
      this.loading = true
      this.content = [...this.$store.getters.content]
      this.resetNewContent()
      this.loading = false
    },
    resetNewContent () {
      this.newContent = {
        name: '',
        url: '',
        instructions: '',
        descText: '',
        descBody: ''
      }
      quillEvent.$emit('syncText', this.newContent.descText)
    },
    canCreate () {
      quillEvent.$emit('getContent')
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newContent.name === '') {
        appMsg.msg = 'Please enter a name for the course content'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newContent.name.toLowerCase() === 'create') {
        appMsg.msg = 'Please use a different name; that name is reserved.'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (this.newContent.instructions === '') {
        appMsg.msg = 'Please enter instructions for the course content'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      for (let c of this.content) {
        if (this.newContent.name.toLowerCase() === c.name.toLowerCase()) {
          appMsg.msg = 'That content name already exists'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
      }
      this.popup = {
        show: true,
        type: 'Creating Content'
      }
    },
    createContent () {
      this.creating = true
      this.newContent.url = this.$store.getters.formatUrl(this.newContent.name)
      this.newContent.descText = this.newText
      this.newContent.descBody = this.quillText
      this.$store.dispatch('createContent', this.newContent).then(c => {
        const appMsg = {
          type: 'success',
          msg: c.name + ' created!'
        }
        this.creating = false
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/content')
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.creating = false
        this.$store.dispatch('showAppMsg', appMsg)
      })
    }
  }
}
</script>

<style lang="stylus">
   @import "~quill/assets/snow"
</style>



// WEBPACK FOOTER //
// src/components/content/CreateContent.vue